import { Link } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  textDecoration: "none",
  color: "inherit",
};

const panelStyle: React.CSSProperties = {
  padding: 24,
  borderRadius: 22,
  border: "1px solid rgba(255, 255, 255, 0.08)",
  background: "linear-gradient(180deg, rgba(19, 28, 58, 0.78), rgba(12, 19, 43, 0.86))",
  boxShadow: "0 14px 40px rgba(0, 0, 0, 0.18)",
  height: "100%",
};

export default function Tools() {
  return (
    <div style={{ maxWidth: 980, margin: "0 auto", padding: "32px 16px 40px" }}>
      <div
        style={{
          padding: "32px 28px",
          borderRadius: 24,
          border: "1px solid rgba(255, 255, 255, 0.08)",
          background:
            "radial-gradient(circle at top left, rgba(109, 94, 252, 0.16), transparent 36%), linear-gradient(180deg, rgba(7, 12, 34, 0.92), rgba(3, 7, 22, 0.98))",
          boxShadow: "0 24px 80px rgba(0, 0, 0, 0.28)",
          marginBottom: 24,
        }}
      >
        <div
          style={{
            fontSize: 13,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            opacity: 0.7,
            marginBottom: 14,
          }}
        >
          Lumia · toolset
        </div>

        <h1 style={{ fontSize: "clamp(2rem, 5vw, 3.1rem)", margin: 0, lineHeight: 1.08 }}>
          Practical construction document tools.
        </h1>

        <p style={{ marginTop: 16, maxWidth: 760, fontSize: "1.05rem", lineHeight: 1.7, opacity: 0.86 }}>
          Start with RAMS for the full document pack, or use the focused tools when you only need a
          Risk Assessment or Method Statement.
        </p>

        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 22 }}>
          <Link
            to="/rams"
            style={{
              textDecoration: "none",
              padding: "12px 18px",
              borderRadius: 999,
              background: "#6d5efc",
              color: "#fff",
              fontWeight: 700,
              boxShadow: "0 12px 36px rgba(109, 94, 252, 0.34)",
            }}
          >
            Create RAMS
          </Link>

          <Link
            to="/support"
            style={{
              textDecoration: "none",
              padding: "12px 18px",
              borderRadius: 999,
              border: "1px solid rgba(255,255,255,0.14)",
              color: "inherit",
            }}
          >
            Need support?
          </Link>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 18,
        }}
      >
        <Link to="/rams" style={cardStyle}>
          <div
            style={{
              ...panelStyle,
              border: "1px solid rgba(109, 94, 252, 0.38)",
              boxShadow: "0 18px 48px rgba(109, 94, 252, 0.16)",
            }}
          >
            <div
              style={{
                display: "inline-block",
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "#9ea7ff",
                marginBottom: 14,
              }}
            >
              Main tool
            </div>

            <h2 style={{ margin: "0 0 12px", fontSize: "1.25rem" }}>RAMS (Combined)</h2>

            <p style={{ margin: "0 0 18px", opacity: 0.84, lineHeight: 1.65 }}>
              Generate a full Risk Assessment and Method Statement in one coherent document, ready to
              review, copy to Word, or export as PDF.
            </p>

            <div style={{ opacity: 0.78, fontSize: 14, marginBottom: 18 }}>
              Best when you need the full pack.
            </div>

            <div style={{ color: "#9ea7ff", fontWeight: 700 }}>Open RAMS →</div>
          </div>
        </Link>

        <Link to="/risk" style={cardStyle}>
          <div style={panelStyle}>
            <div
              style={{
                display: "inline-block",
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                opacity: 0.62,
                marginBottom: 14,
              }}
            >
              Single document
            </div>

            <h2 style={{ margin: "0 0 12px", fontSize: "1.25rem" }}>Risk Assessment</h2>

            <p style={{ margin: "0 0 18px", opacity: 0.84, lineHeight: 1.65 }}>
              Turn rough site notes into a structured UK-style risk assessment with practical hazards,
              controls, and review details.
            </p>

            <div style={{ opacity: 0.78, fontSize: 14, marginBottom: 18 }}>
              Best when RA is all you need.
            </div>

            <div style={{ color: "#9ea7ff", fontWeight: 700 }}>Open Risk →</div>
          </div>
        </Link>

        <Link to="/method" style={cardStyle}>
          <div style={panelStyle}>
            <div
              style={{
                display: "inline-block",
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                opacity: 0.62,
                marginBottom: 14,
              }}
            >
              Single document
            </div>

            <h2 style={{ margin: "0 0 12px", fontSize: "1.25rem" }}>Method Statement</h2>

            <p style={{ margin: "0 0 18px", opacity: 0.84, lineHeight: 1.65 }}>
              Create a practical step-by-step method statement covering sequence, plant, controls,
              interfaces, permits, and emergency arrangements.
            </p>

            <div style={{ opacity: 0.78, fontSize: 14, marginBottom: 18 }}>
              Best when MS is all you need.
            </div>

            <div style={{ color: "#9ea7ff", fontWeight: 700 }}>Open Method →</div>
          </div>
        </Link>
      </div>
    </div>
  );
}